<div class="no-known-content">
    <nz-switch [(ngModel)]="switchValue" style="margin-right: 1em;"></nz-switch>
    <div>{{"No known" | translate}}</div>
    <div class="add-title">&nbsp;</div>
    <div class="add-title">{{"Resolved Problems" | translate}}</div>
</div>